import React, { useState } from "react";
import "./welcome.scss";
import HOD from "../../assets/images/hodd.JPG";
import { Link } from "react-router-dom";
import { Lecturers } from "../../components/Lecturers/Lectuerers";
import { lecturers } from "../../TextData";
export const Welcome = () => {
  const [state, setState] = useState({
    query: "",
    list: lecturers,
  });
  return (
    <>
      <section className="col-md-12 flexy page-background ">
        <div className="col-md-12 page-shadow header-wrapper">
          <div className="col-md-12 banner zoominheader"> </div>
          <div className=" col-md-12 after"></div>
          <div className="icon ">
            <h1>
              <h1>WELCOME ADDRESS</h1>
            </h1>
            <div className="flexy flexyM offset-md-5 mt5">
              {" "}
              <Link to={"/"} className="home-link">
                HOME
              </Link>
              <span>
                <i class="icofont-rounded-right"></i>
              </span>
              <h6>Welcome</h6>
            </div>
          </div>
        </div>
      </section>
      <div className="welcome-body mt3">
        <center>
          <h1 className="col-md-6">
            A Warm Welcome to the Department of Physics, University of Port
            Harcourt
          </h1>
          <p>
            <em>From the Desk of the Head of Department</em>
          </p>
        </center>
        <div className="col-md-8 offset-md-2 mt7 welcome-body">
          <div className="flexy">
            {" "}
            <div className="col-md-6">
              {" "}
              <div className="col-md-11">
                <p>
                  It is with immense pleasure and enthusiasm that I extend a
                  heartfelt welcome to you all on behalf of the Department of
                  Physics at the University of Port Harcourt. As the Head of
                  this department, I am truly honored to have the opportunity to
                  lead a community of scholars, researchers, and enthusiasts who
                  are deeply committed to the pursuit of knowledge and the
                  exploration of the fundamental principles that govern our
                  universe.
                </p>
                <p>
                  At the Department of Physics, we are more than just educators
                  and researchers; we are a family united by our passion for
                  understanding the world through the lens of physics. Whether
                  you are a new or returning student, a member of our esteemed
                  faculty, a dedicated staff member, or a curious visitor, you
                  are an integral part of our vibrant and dynamic community.
                </p>
                <p>
                  Our department has a rich tradition of excellence in both
                  research and education. Our faculty members are leaders in
                  their respective fields, conducting groundbreaking research
                  that pushes the boundaries of human knowledge. They are not
                  only experts in their domains but also dedicated mentors who
                  are committed to nurturing the next generation of physicists.
                </p>
                <p>
                  For our students, this department is a place of growth,
                  exploration, and transformation. It is where you will embark
                  on a journey of discovery, challenging your intellect, honing
                  your problem-solving skills, and gaining a deep understanding
                  of the laws that govern the natural world. Whether your
                  interests lie in theoretical physics, experimental research,
                  or the application of physics to real-world challenges, we are
                  here to support and guide you on your path to success.
                </p>
                <p>
                  As we move forward, the Department of Physics at the
                  University of Port Harcourt remains committed to fostering an
                  inclusive and collaborative environment that encourages
                  innovation and interdisciplinary exploration. We also aim to
                  strengthen our connections with the local community, inviting
                  you to engage with us in our outreach programs, workshops, and
                  events that showcase the wonders of physics.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              {" "}
              <img
                className=""
                src={HOD}
                alt="Scholar"
                width="100%"
                style={{ borderRadius: "20px" }}
              />
              <center>
                <h5 className="mt3">Professor Felix Ugbana Nte </h5>
                <h6 style={{ color: "grey" }}>
                  H.O.D: Department of Physics, University of Port Harcourt
                </h6>
              </center>
            </div>
          </div>
          <p>
            I invite you to explore our website and discover the exciting
            opportunities, courses, and research initiatives that await you
            here. Feel free to reach out to us with any questions or ideas you
            may have. Together, we will continue to push the frontiers of
            physics and make a lasting impact on the world.
          </p>
          <p>
            Thank you for being a part of our community, and I look forward to
            the remarkable journey of discovery and growth that lies ahead.
          </p>
        </div>
      </div>
      <center>
        <h1 className="mt7">Our Leadership</h1>
      </center>
      <div className="row row-cols-2 row-cols-lg-4  g-lg-2 col-md-8 offset-md-2 mt8">
        {state.list.map((data, index) => (
          <Lecturers data={data} />
        ))}
      </div>
    </>
  );
};
